module.exports = __webpack_public_path__ + "img/indexBgc02.png";